module.exports = __webpack_public_path__ + "static/media/01.c9c550fb.jpg";